/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Ramp } from '@goldwasserexchange/react-topmodel';

const inputContainerRampNames = ['inputContainer'];

const inputContentRampNames = ['inputContent'];

export const NewsLetterBoxInput = (props: {
  name: string,
  type: React.InputHTMLAttributes<HTMLInputElement>['type'],
  placeholder: string,
  widthLines?: ouiStyle.InStyleWithMediaQueries['widthLines'],
}) => {
  const {
    name,
    type,
    placeholder,
    widthLines,
  } = props;
  return (
    <Ramp
      rampName={`inputContainer-${name}`}
      rampFallbacks={inputContainerRampNames}
      widthLines={widthLines}
    >
      <Ramp
        rampName={`inputContent-${name}`}
        rampFallbacks={inputContentRampNames}
        name={name}
        type={type}
        placeholder={placeholder}
      />
    </Ramp>
  );
};
